import React, { useState } from "react";
import Footer from "./Footer";
import Header from "./Header";
import Main from "./Main";
import { clsx } from "clsx";
import Drawer from "./Drawer";

interface IHeaderProps extends React.PropsWithChildren {}

export default function Layout({ children }: IHeaderProps) {
  return (
    <div
      className={clsx(
        "flex",
        "flex-col",
        "items-center",
        "min-h-screen",
        "w-full",
      )}
    >
      <Header />
      <Main>{children}</Main>
      <Footer />
    </div>
  );
}
